'use client';

import { ReactElement, ReactNode, useMemo } from 'react';

import { IForm } from '@/react/view-models/Form';
import { FormContext, IFormContext } from '../FormContext';

export interface IFormProviderProps<T> {
  /** The form model that is held by this provider. */
  formModel: IForm<T>;

  /** The component children to be rendered inside the form provider and form component. */
  children: ReactNode;

  /** The form is currently busy processing. */
  isLoading: boolean;
}

/**
 * The `Form` provider supplies wrapped components with the
 * current `FormModel` and a submit callback. This can be used to
 * handle a form fields component.
 */
export const FormProvider = <T,>(
  props: IFormProviderProps<T>
): ReactElement<unknown> => {
  const { children, formModel, isLoading } = props;

  const value = useMemo((): IFormContext => {
    return { form: formModel as IForm, isLoading };
  }, [formModel, isLoading]);

  return <FormContext value={value}>{children}</FormContext>;
};
